module.exports = __webpack_public_path__ + "img/VK.e603188f.png";